const Block = ({ block, dragStart, dragStop, close }) => {
  return (
    <div
      draggable
      onDragStart={(e) => {
        setTimeout(close, 1);
        window.currentDraggedBlock = block;
        setTimeout(() => {
          dragStart(block, e.nativeEvent);
        }, 100);
      }}
      onDragEnd={() => {
        setTimeout(() => {
          dragStop(false);
        }, 100);
      }}
      className="block-item"
      title={block.getLabel()}
    >
      <div
        className="block-media"
        dangerouslySetInnerHTML={{ __html: block.getMedia() }}
      />
      <div className="block-label">{block.getLabel()}</div>
    </div>
  );
};

export default Block;
